module.exports = __webpack_public_path__ + "static/media/expired-icon.60851921.svg";